export { default as GDMTableRow } from './GDMTableRow';

export type { GDMTableRowComponent, GDMTableRowProps } from './GDMTableRow.type';
